const STEP_ZOOM = 0.1;
const MAX_ZOOM = 1.5;

export default {
    data() {
        return {
            startCanvasDimension : {
                height : 0,
                width : 0,
            },
            farthestPoint: {
                x: 0,
                y: 0
            },
            nearestPoint: {
                x: null,
                y: null
            }
        }
    },
    methods: {
        resetData(){
            this.startCanvasDimension = {
                height : 0,
                width : 0,
            };

            this.farthestPoint = {
                x : 0,
                y : 0,
            };

            this.nearestPoint = {
                x : null,
                y : null,
            };
        },
        calculateFarthestPoint(canvas) {
            let nearestPoint, farthestPoint;
            _.map(canvas.getObjects(), object => {
                nearestPoint = this.getNearestPoint(object);
                farthestPoint = this.getFarthestPoint(object)

                this.farthestPoint.x = Math.max(this.farthestPoint.x, farthestPoint.x);
                this.farthestPoint.y = Math.max(this.farthestPoint.y, farthestPoint.y);

                this.nearestPoint.x = this.nearestPoint.x !== null ? Math.min(parseInt(this.nearestPoint.x), parseInt(nearestPoint.x)) : parseInt(nearestPoint.x)
                this.nearestPoint.y = this.nearestPoint.y !== null ? Math.min(parseInt(this.nearestPoint.y), parseInt(nearestPoint.y)) : parseInt(nearestPoint.y)
            })
        },
        setCanvasSize(canvas, height, width) {
            canvas.setHeight(height + 100)
            canvas.setWidth(width + 100)
        },
        getNearestPoint(object) {
            let minX = null, mixY = null;
            let coords = object.getCoords();
            _.map(coords, (coord) => {
                minX = (minX <= coord.x && minX != null) ? minX : coord.x;
                mixY = (mixY <= coord.y && mixY != null) ? mixY : coord.y;
            });

            return {
                x: minX,
                y: mixY
            }

        },
        getFarthestPoint(object) {
            let maxX = null, maxY = null;
            let coords = object.getCoords();
            _.map(coords, (coord) => {
                maxX = (maxX >= coord.x && maxX != null) ? maxX : coord.x;
                maxY = (maxY >= coord.y && maxY != null) ? maxY : coord.y;
            });

            return {
                x: maxX,
                y: maxY
            }
        },

        getCanvas(){
            return this.canvas;
        },
        getCurrentZoom(){
            return this.getCanvas().getZoom();
        },
        bringCloser(){
            let newZoom = this.getCurrentZoom() + STEP_ZOOM;
            if(newZoom > MAX_ZOOM){
                return;
            }

            this.canvasSetZoom(
                this.getCanvas(),
                newZoom
            )

        },
        moveAway(){
            let newZoom = this.getCurrentZoom() - STEP_ZOOM;

            if(newZoom < STEP_ZOOM){
                return;
            }

            this.canvasSetZoom(
                this.getCanvas(),
                newZoom
            )

        },
        canvasSetZoom(canvas, zoom) {
            canvas.setZoom(zoom)
            this.setCanvasSize(
                canvas,
                this.startCanvasDimension.height * zoom,
                this.startCanvasDimension.width * zoom
            )
        },
        setZoomFullScreen(){
            this.canvasSetZoom(this.getCanvas(), this.calculateZoomForFullScreen(this.getCanvas()))
        },
        calculateZoomForFullScreen() {
            this.getCanvas().setZoom(1);
            let canvasWidth =  this.startCanvasDimension.width;
            let canvasHeight = this.startCanvasDimension.height
            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;
            let zoomY = windowHeight > canvasHeight ? this.currentZoom : (windowHeight / canvasHeight)
            let zoomX = windowWidth > canvasWidth ? this.currentZoom : (windowWidth / canvasWidth)
            return  Math.min(zoomY, zoomX)
        },
        setCanvasSizeByMaxCoords(canvas) {
            this.calculateFarthestPoint(canvas);
            this.setInitCanvasDimension(this.farthestPoint.y, this.farthestPoint.x)
            this.setCanvasSize(canvas, this.farthestPoint.y, this.farthestPoint.x)
        },
        setInitCanvasDimension(height, width){
            this.startCanvasDimension.height = height;
            this.startCanvasDimension.width = width;
        }
    }
}
